module.exports = __webpack_public_path__ + "img/del-hanging.77f360f7.svg";